export default

    class IndicatoresController {

    constructor(resource) {
        this._baseUrl = 'indicators';
        this._resource = resource;
    }

    getAllIndicators({ano = '2023', mes = '5' } = {}){
        return this._resource(`indicators`, {ano: ano, mes: mes})
                        .get()
                        .then(v =>  v, err => {throw(err);});
    }
    
    getAllDashVehicles({ano = null, } = {}){
        return this._resource(`dash`, {ano: ano, })
                        .get()
                        .then(v =>  v, err => {throw(err);});
    }    

    getAllBreakdown({ano = '2023', mes = '5' } = {}){
        return this._resource(`indicatorsbreakdown`, {ano: ano, mes: mes })
                        .get()
                        .then(v =>  v, err => {throw(err);});
    }

    getServices({ano = '2023', mes = '5' } = {}){
        return this._resource(`indicatorservices`, {ano: ano, mes: mes })
                        .get()
                        .then(v =>  v, err => {throw(err);});
    }
    
}